import React from 'react';
import { Rect } from 'react-konva';
import { generateCrystalColorHex } from 'utils/ExperimentUtils';
import withDrawingContainer, { withDrawingContainerProps } from './withDrawingContainer';
import { CrystalUpdateDetails, DrawingType, NEW_CRYSTAL_COLOUR } from '../constants';

interface Props extends withDrawingContainerProps {
  isChecked: boolean;
}
const CrystalDrawing = (props: Props) => {
  const { id, width, height, isChecked, isSelected, rectRef } = props;

  return (
    <Rect
      id={`crsytaldrawing-${id?.toString()}`}
      ref={rectRef}
      width={width}
      height={height}
      stroke={id > 0 ? generateCrystalColorHex(id) : NEW_CRYSTAL_COLOUR}
      strokeWidth={isChecked ? 5 : 2}
      opacity={isChecked || isSelected ? 0.5 : 1}
      shadowBlur={isChecked || isSelected ? 10 : 0}
      shadowColor={isChecked || isSelected ? 'black' : ''}
      shadowOpacity={isChecked || isSelected ? 5 : 0}
      shadowEnabled={isChecked || isSelected ? true : false}
    />
  );
};

function moveActionPreProcessor(
  props: Props,
  x: number,
  y: number,
): CrystalUpdateDetails {
  const {
    x: dbX,
    y: dbY,
    height: dbHeight,
    width: dbWidth,
  } = props.tpObject.convertRectangleDrawingForDb(x, y, props.width, props.height);
  return { x, y, width: props.width, height: props.height, dbX, dbY, dbWidth, dbHeight };
}

const transformActionPreProcessor = (
  props: Props,
  width: number,
  height: number,
): CrystalUpdateDetails => {
  const { width: dbWidth, height: dbHeight } = props.tpObject.ConvertPointsToCrystal({
    width,
    height,
  });

  return { width, height, dbHeight, dbWidth };
};
export default withDrawingContainer(
  CrystalDrawing,
  DrawingType.CRYSTAL,
  moveActionPreProcessor,
  transformActionPreProcessor,
);
